import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { EntityTypeConfig } from '@model/entity-type-config';
import { OnInit, Component, Input } from '@angular/core';
import { Entity } from '@model/entities/entity';
import { Profile } from '@interface/profile';
import { UserService } from '@service/user/user.service';
import { ProfileTypeIdentifier } from '@enum/profile-type-identifier';

@Component({
  template: '',
})
export abstract class EntityDisplayComponent implements OnInit {
  protected abstract entityTypeIdentifier: EntityTypeIdentifier;

  protected entityTypeConfig: EntityTypeConfig = null;

  public author: Profile = null;

  @Input()
  public abstract entity: Entity;

  /*
    remembers if this display is a preview (in a create or edit etc.)
    disables like / share etc.
  */
  @Input()
  public live: boolean = true;

  public computeAuthor() {
    if (this.live) {
      if (this.entity.profile_type === ProfileTypeIdentifier.business)
        this.author = this.entity.frontend_user.company_profile;
      else this.author = this.entity.frontend_user;
    } else {
      if (this.entity.profile_type === ProfileTypeIdentifier.business)
        this.author = this.UserService.user.company_profile;
      else this.author = this.UserService.user;
    }
  }

  constructor(
    protected EntityTypeConfigService: EntityTypeConfigService,
    protected UserService: UserService,
  ) {}

  public ngOnInit() {
    this.entityTypeConfig = this.EntityTypeConfigService.getConfigByName(this.entityTypeIdentifier);
  }
}
